var map = {
	"./AnonymousEmpoweredPatient.jpeg": 2549,
	"./Blockchain_Digital.jpg": 4148,
	"./Blockchain_Digital.png": 9591,
	"./Digital_privacy.jpeg": 6532,
	"./DoctorDigital_Tablet.jpg": 3718,
	"./DoctorDigital_Tablet.png": 674,
	"./MyDataMyDecision.jpeg": 6555,
	"./Old_Baby.jpg": 7926,
	"./polymorphDigital.jpg": 7840,
	"./slider1.jpg": 3958,
	"./slider2.jpg": 4305,
	"./slider3.jpg": 6260,
	"./slider3o.jpg": 85,
	"./slider4.jpg": 1199,
	"./transparency_blockchain.jpeg": 2694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6666;